// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2dzxe","label":"LabeledBox_label__1h17N"};